import React from 'react';

function SkillsUpdates() {
  const recentSkills = [
    { name: 'Market Analysis AI', date: '2024-03-01' },
    { name: 'Business Plan Generator', date: '2024-02-28' },
    { name: 'Legal Compliance Checker', date: '2024-02-25' }
  ];

  return (
    <div className="skills-updates">
      <h3>Recent Skills Added</h3>
      <ul>
        {recentSkills.map((skill, index) => (
          <li key={index}>
            <strong>{skill.name}</strong> - {skill.date}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SkillsUpdates;
